import { getApi } from "../helpers/api";

async function download(endpoint: string, data: any) {
  return getApi().post(`/${endpoint}`, data, {
    responseType: 'arraybuffer',    
  });
}

export default download;
